import { render, staticRenderFns } from "./serviceListItem.vue?vue&type=template&id=b9ba6abc&scoped=true"
import script from "./serviceListItem.vue?vue&type=script&lang=js"
export * from "./serviceListItem.vue?vue&type=script&lang=js"
import style0 from "./serviceListItem.vue?vue&type=style&index=0&id=b9ba6abc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba6abc",
  null
  
)

export default component.exports